<template>
  <div class="chart-box">
    <el-row :gutter="20" style="margin: 30px 0;">
      <el-col :span="6">
        <centerLeft defultIndex="3-2" />
      </el-col>
      <el-col :span="18">
        <el-card class="box-card" shadow="never">
          <el-breadcrumb
            separator-class="el-icon-arrow-right"
            class="type-opr"
            style="margin:0 0  10px 0;"
          >
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>我的关注</el-breadcrumb-item>
          </el-breadcrumb>
          <el-tabs v-model="activeName" type="card" style="margin: 30px 0;">
            <el-tab-pane label="我关注的学者" name="second">
              <el-row :gutter="20">
                <el-col :span="8" v-for="(item, index) in subList" :key="item.userId">
                  <el-card :body-style="{ padding: '0px' }" shadow="hover" class="talent-card">
                    <router-link class="recommend" :to="{path:'personal',query:{id:item.userId}}">
                      <el-avatar
                        class="talent-pic"
                        shape="square"
                        :size="100"
                        fit="fill"
                        :src="item.iconUrl"
                      ></el-avatar>
                    </router-link>
                    <div class="talent-info">
                      <router-link class="recommend" :to="{path:'/personal',query:{id:item.atUserId}}">
                        <p>
                          <b>{{item.atUserName}}</b>
                        </p>
                        <p>{{item.atUserDeptname}}</p>
                      </router-link>
                      <p class="talent-p">
                        成果量：
                        <span class="num">{{item.atDissnum}}</span> 全文量：
                        <span class="num">{{item.atFullnum}}</span>
                      </p>
                      <p class="talent-p">研究领域：{{item.atUserDeptname}}</p>
                    </div>
                  </el-card>
                </el-col>
              </el-row>
              <el-pagination
                background
                layout="prev, pager, next"
                :total="total"
                :current-page="currentPage"
                :page-size="pageSizes"
                @current-change="currentChange"
                style="text-align: right"
              ></el-pagination>
            </el-tab-pane>
            <el-tab-pane label="我关注的科室" name="third">
              <el-row :gutter="20">
                <el-col :span="6" v-for="(item, index) in talList" :key="item.strid">
                  <el-card
                    :body-style="{ padding: '0px' }"
                    shadow="hover"
                    class="talent-card subject-card"
                  >
                    <router-link :to="{path:'department',query:{id:item.strid}}">
                      <el-row :gutter="20">
                        <el-col :span="10" class="subject-left">
                          <p>{{item.orgName}}</p>
                        </el-col>
                        <el-col :span="14" class="subject-right">
                          <p>
                            成果量：
                            <span>{{item.allResult}}</span>
                          </p>
                          <p>
                            全文量：
                            <span>{{item.fullTextCount}}</span>
                          </p>
                        </el-col>
                      </el-row>
                    </router-link>
                  </el-card>
                </el-col>
              </el-row>
            </el-tab-pane>
          </el-tabs>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios'
import centerLeft from '../../components/center-left.vue'
export default {
  name: 'claim',
  components: {
    centerLeft,
  },
  data() {
    return {
      activeName: 'second',
      isRouter: true,
      activeIndex: '1-1',
      subList: [],
      talList: [],
      total: 0,
      currentPage: 1,
      pageSizes: 5,
      userId: '',
    }
  },
  methods: {
    currentChange(val) {
      this.searchForm.pageNo = val
      this.getConcern()
    },
    getConcern(id) {
      let currThis = this
      axios({
        method: 'get',
        url: '/api/member/memberConcern/' + id,
      })
        .then(function (response) {
          console.log(response)
          currThis.subList = response.data.data.resultList
          currThis.total = response.data.data.totalCount
        })
        .catch(function (thrown) {
          console.log(thrown)
        })
    },
  },
  mounted() {
    //this.userId=localStorage.getItem('userId');
    this.userId = this.$cookies.get('rtnVal')
    this.getConcern(this.userId)
  },
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/center/follow.vue